import { Directive } from '@angular/core';

@Directive({ selector: '[napaCustomDialogContent]' })
export class CustomDialogContentDirective {}
